/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import VisitActivityTree from "../VisitActivityTree/VisitActivityTree.vue";
import ArmVisitActivityTree from "../ARM/ArmVisitTree.vue";

export default {
    name: "visitInfo",
    components: {VisitActivityTree
        ,
        ArmVisitActivityTree
    },
    props: {
        visitData: {
            type: Object,
            required: true
        },
        version: {
            type: String,
            required: false
        },
        studyId: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            isArmSpecific: false,
            studyDetails: {},
            baseurl: process.env.VUE_APP_Service_URL,
            head: {
                headers: {
                    Authorization: "Bearer " + store.getters.getIdToken,
                    "Content-Type": "application/json",
                },
            },
            studyId: "",
            versiondetailsobj: {},
            selectedVersion: this.version || ""
        };
    },
    async mounted() {
        console.log("Visit Summary Component Mounted");
        this.studyId = store.getters.getStudyIs
        await this.getStudyDetails();
        window.addEventListener("studyIdChanged", async () => {
            this.studyId = store.getters.getStudyIs

            await this.getStudyDetails();
            this.selectedVersion = this.studyDetails.currentVersion;


        });
         this.selectedVersion = this.studyDetails.currentVersion;
    },
    methods: {
        closePage() {
            this.$router.push("/studyProfile")
        },
        async getStudyDetails() {
            await axios.get(`${this.baseurl}/management/study/getbyid?id=${this.studyId}`, this.head)
                .then((res) => {
                    console.log("study details ", res.data);
                    this.studyDetails = res.data;
                    this.versiondetailsobj = res.data;
                    const currentVersion = res.data.currentVersion;

                    const versionObj = res.data.versions.find(
                        v => v.version === currentVersion
                    );

                    this.isArmSpecific = versionObj ? versionObj.isArmSpecific : false;
                     this.routpage();

                    console.log("Is Arm Specific:", this.isArmSpecific);


                })
                .catch(err => console.log("error in get study", err));
        },
        async routpage() {
            if (this.$route.name !== "visitInfo") return;

            if (this.isArmSpecific) {
                this.$router.push("/Scheduleofactivities");
            } else {
                this.$router.push({
                    name: "visitInfo",
                    params: { version: this.selectedVersion }
                });
            }
        }

    }
}